var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-modal--wrap"},[_c('video',{attrs:{"autoplay":"","controls":"","playsinline":"","src":_vm.link}})])
}
var staticRenderFns = []

export { render, staticRenderFns }